export enum Endpoint {
  saveBundleUrl = "api/Bundle",
  setBundleRestrictedAccessOptionsUrl = "api/Bundle/setRestrictedAccessOptions",
  changeBundleAccessUrl = "api/Bundle/changeBundleAccess",
  getBundleByIdUrl = "api/Bundle/bundleByBundleId",
  inAppropriateBundleUrl = "api/Flow/reportflow",
  deleteBundleUrl = "api/Bundle/deleteBundle",
  getBundleUrl = "api/Bundle/getAllUserBundles",
  getBundleByFlowIdUrl = "api/Bundle/bundleDetailsByFlowId",
  getUsersVoucherCodesUrl = "api/VoucherCode/couponCodeDiscountValue",
  getFlowsByCategoriesUrl = "api/Flow/flowsByCategories", // URL to web api
  getFlowsByIdUrl = "api/Flow/flowByFlowId", // URL to web api
  postContactUsUrl = "api/ContactUs/postContactUs",
  getContactUsRequestsUrl = "api/ContactUs/getContactUsRequests",
  getBookAPilotRequestsUrl = "api/BookAPilot/getBookAPilotRequests",
  sendFeedbackUrl = "api/UserFeedback/sendFeedback",
  getAllFeedbackUrl = "api/UserFeedback/getAllFeedback",
  getFeedbackByEmailUrl = "api/UserFeedback/getFeedbackByEmail",
  getFeedbackByRowKeyUrl = "api/UserFeedback/getFeedbackByRowKey",
  updateFeedbackUrl = "api/UserFeedback/updateFeedback",
  deleteFeedbackUrl = "api/UserFeedback/deleteFeedback",
  approvedUrl = "api/Flow/usersApprovedFlows",
  bookMarkUrl = "api/Flow/usersBookMarkFlows",
  draftUrl = "api/Flow/usersDraftFlows",
  usersFlowCommentsUrl = "api/FlowComment/allflowComment",
  addFlowCommentUrl = "api/FlowComment/flowComment",
  getVoucherCodeUrl = "api/VoucherCode/voucherCode",
  deleteFlowCommentUrl = "api/FlowComment/deleteFlowComment",
  editCommentUrl = "api/FlowComment/flowComment",
  IsFlowLikedUrl = "api/Flow/isFlowLiked",
  LikeFlowUrl = "api/Flow/likeFlow",
  likeBundleUrl = "api/Bundle/likeBundle",
  changeTransferOwnershipBundle = "api/Bundle/changeTransferOwnership",
  IsUserFollowingUrl = "api/Flow/isUserFollowingUser",
  FollowUserUrl = "api/Flow/postUserFollower",
  IsFlowBookMarkedStatusUrl = "api/Flow/flowBookMarkedStatus",
  PostBookMarkFlowUrl = "api/Flow/postBookMarkFlow",
  deleteFlowUrl = "api/Flow/deleteFlow",
  inAppropriateUrl = "api/Flow/reportflow",
  checkIfUserReportedReviewUrl = "api/Flow/checkIfUserReportedReview",
  getNotificationUrl = "api/Notification/userNotifications",
  markAsReadNotificationsUrl = "api/Notification/markAsReadNotifications",
  createFlowUrl = "api/Flow",
  postAccessType = "api/Flow/changeFlowAccess",
  getFlowsByInputCategoryUrl = "api/Flow/flowsByInputCategory",
  getIsFlowViewedUrl = "api/Flow/isFlowViewed",
  getAllFlowsUrl = "api/Flow/allFlows",
  getAllUserFlowsUrl = "api/Flow/allUserFlows",
  getOrgTeamGuidesUrl = "api/Flow/orgTeamGuides",
  getSearchFlowsUrl = "api/Flow/searchedFlows",
  getSearchApprovedFlowsByFlowQueryModel = "api/Flow/getSearchApprovedFlowsByFlowQueryModel",
  getSearchApprovedBundleByBundleQueryModel = "api/Bundle/getSearchApprovedBundleByBundleQueryModel",
  getUserBundleUrl = "api/Bundle/getUserBundles",
  getUserPublicBundles = "api/Bundle/getUserPublicBundles",
  postFollowUserUrl = "api/Flow/postUserFollower",
  postTransferOwnership = "api/TransferOwnership",
  getUserTransferOwnershipDetails = "api/TransferOwnership/getUserTransferOwnershipDetails",
  getTransferOwnershipByKey = "api/TransferOwnership/getTransferOwnershipByKey",
  getTransferOwnershipByContentId = "api/TransferOwnership/getTransferOwnershipByContentId",
  deleteTransferOwnershipByKey = "api/TransferOwnership/deleteTransferOwnership",
  flowCheckoutUrl = "api/Payments/checkout",
  getFlowsByItemsRequired = "api/Flow/flowsByItemsRequired",
  postLikeFlowCommentUrl = "api/FlowComment/likedFlowComment",
  PostLinkClickUrl = "api/Flow/LinkClick",
  getProfileUrl = "api/User/GetCustomerProfileByEmail",
  getProfileContentCountsUrl = "api/User/GetProfileContentCounts",
  viewUserProfileUrl = "api/User/ViewOtherUserProfile",
  getAllUsersUrl = "api/User/GetAllUsers",
  getFollowersUrl = "api/User/getFollowerUsers",
  getFollowingUrl = "api/User/getFollowingUsers",
  customerModel = "api/User/saveCustomerProfileByEmail",
  saveSettingsForCustomer = "api/User/saveSettingsForCustomerProfileByEmail",
  saveNotifySettingsForCustomer = "api/User/saveNotificationSettingsForCustomerProfileByEmail",
  saveDonateSettingsForCustomer = "api/User/saveDonateSettingsForCustomerProfileByEmail",
  saveDefaultViewSettingsForCustomer = "api/User/saveDefaultViewSettingsForCustomerProfileByEmail",
  saveThemeSettingsForCustomer = "api/User/saveThemeSettingsForCustomerProfileByEmail",
  saveCollaborationSettingsForCustomer = "api/User/saveCollaborationSettingsForCustomerProfileByEmail",

  // Collaboration Requests
  sendCollaborationRequestUrl = "api/CollaborationRequest/sendRequest",
  getCollaborationRequestsByOwnerUrl = "api/CollaborationRequest/getRequestsByOwner",
  getCollaborationRequestsByRequesterUrl = "api/CollaborationRequest/getRequestsByRequester",
  approveCollaborationRequestUrl = "api/CollaborationRequest/approveRequest",
  rejectCollaborationRequestUrl = "api/CollaborationRequest/rejectRequest",
  withdrawCollaborationRequestUrl = "api/CollaborationRequest/withdrawRequest",
  userEmailExists = "api/User/GetUserWithEmailAddressExists",
  changeUserNameUrl = "api/User/PostChangeUserName",
  getUserByUserNameUrl = "api/User/getUserByUserName",
  getActivationCodeUrl = "api/User/getActivationCode",
  getProfilepicUrl = "api/User/GetCustomerProfileByEmail",
  registerUser = "api/User",
  deleteUser = "api/User/deleteAccount",
  activateAccount = "api/User/activateAccount",
  forgetPassword = "api/User/forgotPassword",
  ChangePassword = "api/User/PostChangePassword",
  getPurchasedHistoryFunds = "api/User/getPurchaseHistoryByType",
  getFundByCustomerRowKey = "api/User/getFundByCustomerRowKey",
  getConsultationsByDate = "api/User/getConsultationsByDate",
  getConsultations = "api/User/getConsultations",
  saveContentCreatorConsultationsFeedback = "api/User/saveContentCreatorConsultationsFeedback",
  saveUserConsultationsFeedback = "api/User/saveUserConsultationsFeedback",
  getUserConsultations = "api/User/getUserConsultations",
  getConsultationsByRowKey = "api/User/getConsultationsByRowKey",
  bookConsultation = "api/User/bookConsultation",
  updateConsultationOccurrence = "api/User/updateConsultationOccurrence",
  SupportFaq = "api/Faq",
  CreateAboutUs = "api/AdminDashboard",
  getAboutUs = "api/AdminDashboard/getLatestAboutUsDetails",
  deleteInapproperiateFlow = "api/AdminDashboard/deleteInapproperiateFlow",
  getAboutUsDetails = "api/AdminDashboard/getAboutUsDetails",
  deleteSupportFaq = "api/Faq/deleteFaq",
  getSupportFaq = "api/Faq/getFaqsDetails",
  getFaqDetailsByQuestion = "api/Faq/getFaqDetailsByQuestion",
  //Not changed endpoints urls

  //baseUrl = "https://timitimsorg-staging.azurewebsites.net/",
  // baseUrl = "http://localhost:21255/";

  PostPageViewUrl = "api/PageView/pageViewDetails",
  GetPageViewDetailsUrl = "api/PageView/getPageViews",
  GetContentCount = "api/PageView/getFlowCount",
  GetContent = "api/PageView/getFlowContent",
  GetContentLikeCount = "api/PageView/getContentLikeCount",
  GetContentCommentCount = "api/PageView/getContentCommentCount",
  GetContentSaveCount = "api/PageView/getContentSaveCount",
  GetBundleContentCount = "api/PageView/getBundleCount",
  GetPurchaseByConsult = "api/PageView/getPurchaseByConsult",
  getUserDashboardUrl = "api/UserDashboard/getUserDashboard", // URL to web api
  getAllUserData = "api/UserDashboard/getAllUserData", // URL to web api
  updateUserRoleDetail = "api/UserDashboard/updateUserRoleDetail", // URL to web api
  getAllPurchaseDetails = "api/UserDashboard/getAllPurchaseDetails", // URL to web api
  getAllReportedContent = "api/UserDashboard/getAllReportedContent", // URL to web api
  getUserDashboardFlows = "api/UserDashboard/getUserDashboardFlows",
  getUserDashboardBundles = "api/UserDashboard/getUserDashboardBundles",
  getUserDashboardPaidFlows = "api/UserDashboard/getUserDashboardPaidFlows",
  getUserDashboardPaidBundles = "api/UserDashboard/getUserDashboardPaidBundles",
  GetLinkClickUrl = "api/Flow/GetLinkClicks",
  GetAllLinkClickUrl = "api/Flow/GetAllLinkClicks",
  GetAllBundleLinkClicks = "api/Flow/GetAllBundleLinkClicks",
  GetAllPageViews = "api/PageView/getAllPageViews",
  updateTimeSpentOnFlowUrl = "api/Flow/UpdateTimeSpentOnFlow",
  getCouponCodeDiscountValueUrl = "api/VoucherCode/getCouponCodeDiscountValue",
  purchasedUrl = "api/Flow/usersPurchasedFlows",
  login = "api/Authentication/login",
  refresh = "api/Authentication/refresh",
  passkeyRegisterOptions = "api/Passkey/register/options",
  passkeyRegisterVerify = "api/Passkey/register/verify",
  passkeyLoginOptions = "api/Passkey/login/options",
  passkeyLoginCheck = "api/Passkey/login/check",
  passkeyLoginVerify = "api/Passkey/login/verify",
  passkeyList = "api/Passkey",
  passkeyRevoke = "api/Passkey/",
  passkeyRename = "api/Passkey/",
  searchFlowsUrl = "api/Search/searchFlows",
  searchBundlesUrl = "api/Search/searchBundles",
  searchUsersUrl = "api/Search/searchUsers",
  searchBlogsUrl = "api/Search/searchBlogs",
  searchFaqsUrl = "api/Search/searchFaqs",
  searchItemsRequiredUrl = "api/Search/searchItemsRequired",
  flowChatAskUrl = "api/FlowChat/ask",
  flowChatHistoryUrl = "api/FlowChat/history",
  rephraseTextUrl = "api/AI/rephraseText",
  generateKeyWord = "api/AI/generateKeyWord",
  createBlog = "api/Blog",
  getUserBlogsDetails = "api/Blog/getUserBlogsDetails",
  getAllBlogs = "api/Blog/getAllBlogs",
  getBlogsByEmbeddedContent = "api/Blog/getBlogsByEmbeddedContent",
  getBlogDetailsByCategory = "api/Blog/getBlogDetailsByCategory",
  getBlogsByKey = "api/Blog/getBlogsByKey",
  deleteBlog = "api/Blog/deleteBlog",
  createPermissionsDetail = "api/Permissions",
  getAllPermissionsDetail = "api/Permissions/getAllPermissions",
  getUserPermissionsDetails = "api/Permissions/getUserPermissionsDetails",
  getUserPermissionsDetailsByRole = "api/Permissions/getUserPermissionsDetailsByRole",

  // Enhanced Flow Access Control Endpoints
  getAccessControlUrl = "api/FlowAccessControl/getAccessControl",
  setRestrictedAccessOptionsUrl = "api/Flow/setRestrictedAccessOptions",
  checkFlowAccessUrl = "api/Flow/checkFlowAccess",
  requestFlowAccessUrl = "api/FlowAccessRequest/requestAccess",
  getAccessRequestsByOwnerUrl = "api/FlowAccessRequest/getRequestsByOwner",
  getAccessRequestsByRequesterUrl = "api/FlowAccessRequest/getRequestsByRequester",
  approveAccessRequestUrl = "api/FlowAccessRequest/approveRequest",
  rejectAccessRequestUrl = "api/FlowAccessRequest/rejectRequest",
  deleteAccessRequestUrl = "api/FlowAccessRequest/deleteRequest",
  saveStepProgressUrl = "api/Flow/saveStepProgress",
  getFlowStepProgressUrl = "api/Flow/getFlowStepProgress",
  toggleStepBookmarkUrl = "api/Flow/toggleStepBookmark",
  getFlowStepBookmarksUrl = "api/Flow/getFlowStepBookmarks",
  updateTaggedItemUrl = "api/Flow/updateTaggedItem",
  createFlowShortUrl = "api/FlowShort/createFlowShort",
  getShortsByUserEmailUrl = "api/FlowShort/getShortsByUserEmail",
  getShortsByFlowIdUrl = "api/FlowShort/getShortsByFlowId",
  likeFlowShortUrl = "api/FlowShort/likeFlowShort",
  deleteFlowShortUrl = "api/FlowShort/deleteFlowShort",
  getAllShortsUrl = "api/FlowShort/getAllShorts",
  createFlowReviewUrl = "api/FlowReview/createFlowReview",
  getFlowReviewsUrl = "api/FlowReview/getFlowReviews",
  respondToReviewUrl = "api/FlowReview/respondToReview",
  respondToIssueUrl = "api/FlowReview/respondToIssue",
  getCreatorReviewsUrl = "api/FlowReview/getCreatorReviews",
  getReviewsByUserEmailUrl = "api/FlowReview/getReviewsByUserEmail",
  getFlowShortsUrl = "api/FlowReview/getFlowShorts",
  getUserShortsUrl = "api/FlowReview/getUserShorts",
  markReviewHelpfulUrl = "api/FlowReview/markReviewHelpful",
  moderateReviewUrl = "api/FlowReview/moderateReview",
  moderateIssueUrl = "api/FlowReview/moderateIssue",
  updateReviewRatingUrl = "api/FlowReview/updateReviewRating",

  // Collaboration user search
  searchCollabUsersUrl = "api/User/searchCollabUsers",

  // Flow Collaboration
  sendCollabInviteUrl = "api/FlowCollaboration/sendInvite",
  acceptCollabInviteUrl = "api/FlowCollaboration/acceptInvite",
  rejectCollabInviteUrl = "api/FlowCollaboration/rejectInvite",
  cancelCollabInviteUrl = "api/FlowCollaboration/cancelInvite",
  sentCollabInvitesUrl = "api/FlowCollaboration/sentInvites",
  receivedCollabInvitesUrl = "api/FlowCollaboration/receivedInvites",
  invitesByFlowUrl = "api/FlowCollaboration/invitesByFlow",

  // Versioning - Flow
  flowVersionHistoryUrl = "api/Flow/version-history",
  flowByVersionUrl = "api/Flow/by-version",
  createFlowVersionUrl = "api/Flow/create-version",
  restoreFlowVersionUrl = "api/Flow/restore-version",
  deleteFlowVersionUrl = "api/Flow/delete-version",

  // Versioning - Bundle
  bundleVersionHistoryUrl = "api/Bundle/version-history",
  bundleByVersionUrl = "api/Bundle/by-version",
  createBundleVersionUrl = "api/Bundle/create-version",
  restoreBundleVersionUrl = "api/Bundle/restore-version",
  deleteBundleVersionUrl = "api/Bundle/delete-version",

  // Frontline ops (NEW features)
  frontlineApprovalActionUrl = "api/frontline/approval/action",
  frontlineKeepPublishedLiveUrl = "api/frontline/approval/keep-live",
  frontlineApprovalPendingUrl = "api/frontline/approval/pending",
  frontlineChecklistGenerateUrl = "api/frontline/checklist/generate",
  frontlineChecklistApproveUrl = "api/frontline/checklist/approve",
  frontlineChecklistListUrl = "api/frontline/checklist",
  frontlineChecklistCompletionUrl = "api/frontline/checklist/completion",
  frontlineOpsEventUrl = "api/frontline/ops/event",
  frontlineOpsAnalyticsUrl = "api/frontline/ops/analytics",
  frontlineTaskSessionUrl = "api/frontline/ops/task-session",
  frontlineTaskRunUrl = "api/frontline/ops/task-run",
  frontlineQuestionResponseUrl = "api/frontline/question-response",

  // Content activity / audit
  contentActivityUrl = "api/content-activity",
  contentApprovalStatusUrl = "api/content-activity/approval-status",

  // Organization tenancy
  organizationOnboardUrl = "api/organization/onboard",
  organizationContextUrl = "api/organization/context",
  organizationByIdUrl = "api/organization",
}
